"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { usePathname, useParams } from "next/navigation";
import type { Breadcrumb } from "../types";
import { getBreadcrumbs } from "../lib/breadcrumbs";
export default function useBreadcrumbs() {
  const $ = _c(5);
  const [breadcrumbs, setBreadcrumbs] = useState(_temp);
  const pathname = usePathname();
  const params = useParams();
  let t0;
  if ($[0] !== params || $[1] !== pathname) {
    t0 = () => {
      const breadcrumbs_0 = getBreadcrumbs(pathname, params);
      if (breadcrumbs_0) {
        setBreadcrumbs(breadcrumbs_0);
      }
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== pathname) {
    t1 = [pathname];
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return breadcrumbs;
}
function _temp() {
  return getBreadcrumbs() || [];
}